module.exports = __webpack_public_path__ + "f7e35b5f1888b823592d5dcef3a6972c.png";